export default __webpack_public_path__ + "static/media/tyre-stack.5eca879c.svg";